/**
 * afterLogin — send the person back to the "Allow Claude?" page after they sign in (SUN-85).
 *
 * Only paths under ALLOWED are kept, so this can never be used to send someone to another site
 * or to an arbitrary AURA page. Read once, then forgotten.
 */
const KEY = 'aura-after-login';
const ALLOWED = '/kiaan/connect-claude/authorize?';

const safe = (path: string | null): string | null =>
  path && path.startsWith(ALLOWED) && !path.includes('//') && !path.includes('\\') ? path : null;

export function rememberAfterLogin(path: string): void {
  try {
    if (safe(path)) sessionStorage.setItem(KEY, path);
  } catch {
    // Private mode: the person opens the link again after signing in.
  }
}

export function takeAfterLogin(): string | null {
  try {
    const path = safe(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return path;
  } catch {
    return null;
  }
}
